import { render, staticRenderFns } from "./ChoosePeriod.vue?vue&type=template&id=1f237017&"
import script from "./ChoosePeriod.vue?vue&type=script&lang=js&"
export * from "./ChoosePeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports